export const PATH_FLIGHTS_HOME = "/flights/";
export const PATH_HOTELS_HOME = "/hotels/";
export const PATH_CARS_HOME = "/cars/";
export const PATH_PREMIUM_STAYS = "/premium-stays/";
export const PATH_PREMIUM_VACATION_RENTALS =
  PATH_PREMIUM_STAYS + "vacation-rentals/";
